<template>
  <div class="common-list">

    <template v-if="isdisble">
      <div class="common-list">
        <Table :columns="callpoecolumns" :data="warningLists"></Table>
      </div>

      <div class="common-page fr" style="margin-right:20px" v-if='pageInfo.total'>
        <Page show-total show-elevator show-sizer :total="pageInfo.total" :current="pageInfo.current" :page-size='pageInfo.size' @on-change='getWarningLists' @on-page-size-change='getRuleListsSize'>
        </Page>

      </div>
    </template>

    <div v-else style="height:200px" class="u-flex mw u-row-center">
      <Spin></Spin>
    </div>
  </div>
</template>
<script>
  import api from "@/api";
  import moment from 'moment'
  import ls from 'store2'
  import {
    alarmPage
  } from '@/api/business/rhdetail'
  export default {
    props: ["curId", 'alarmStatus', "graphDeviceComponentId"],
    data() {
      return {
        pageInfo: {
          size: 10,
          current: 1,
          total: 10,
        },

        callpoecolumns: [],
        warningLists: [],
        isdisble: true
      }
    },
   
    
    mounted() {
      this.init()
    },
    methods: {
      getRuleListsSize(size) {
        this.pageInfo.size = size;
        this.getWarningLists(1);
      },
      init() {
        this.callpoecolumns = [{
            title: "报警描述",
            key: "describe",
            width: 500,
            render: (h, params) => {
              const desc = params.row.describe;
              let desc290 = "";
              if (desc && desc.length > 290)
                desc290 = desc.substring(0, 290) + "...";
              else desc290 = desc || "-";
              return h("div", desc290);
            },
          },
          {
            title: "报警开始时间",
            key: "alarmStartTime",
            render: (h, params) => {
              const item = params.row
              return h("div", item.alarmStartTime || "-");
            }
          },
          {
            title: "报警结束时间",
            key: "alarmEndTime",
            render: (h, params) => {

              const {
                index
              } = params
              const item = params.row;
              let msg = "" //da
              let alarmStatus = this.alarmStatus
              if (index == 0) { //当第一条的时候 如果状态不是正常的状态下  显示- 否则则正常显示
                if (alarmStatus == 0 || alarmStatus == 2) {
                  msg = item.alarmEndTime
                } else {
                  msg = item.alarmEndTime
                }
              } else {
                msg = item.alarmEndTime || "-"
              }

              return h("div", msg || "-");
            },
          },
          {
            title: "报警持续时间",
            key: "alarmDuration",
            width: 140,
            align: 'left',
            render: (h, params) => {
              const item = params.row;


              return h(
                "div", {
                  style: {
                    whiteSpace: 'nowrap'
                  }
                },
                this.timeChange(item.alarmDuration)
              );

            },
          },
          {
            title: "操作",
            key: "address",
            width: 150,
            align: 'left',
            className: "action",
            render: (h, params) => {
              const item = params.row;
              return h("div", [
                h(
                  "span", {
                    props: {
                      size: "small",
                    },
                    style: {
                      color: "#0c479d", //"#e9aa69",
                      cursor: "pointer",
                      // marginRight: "10px"
                    },
                    on: {
                      click: () => {


                        this.nvtodetl(item)
                      },
                    },
                  },
                  "详情"
                ),
              ]);
            },
          },
        ]
        this.getWarningLists()
      },
      async nvtodetl(item) {

        let curId = this.curId
        let graphDeviceComponentId = this.graphDeviceComponentId
    
        ls.set(
          "warningDetail_" + item.identifierAlarmRecordId,
          item
        );

        const routeUrl = this.$router.resolve({
          path: `/warning/record/${item.identifierAlarmRecordId}?oilSiteId=${item.oilSiteId}&curId=${curId}&graphDeviceComponentId=${graphDeviceComponentId}`,
        });

        window.open(routeUrl.href, "_blank");
        // this.$router.push(
        //   `/warning/record/${item.id}?oilSiteId=${item.oilSiteId}&curId=${curId}&graphDeviceComponentId=${graphDeviceComponentId}`
        // );
      },
      // 加载报警记录
      async getWarningLists(page) {
        this.isdisble = false
        if (page) this.pageInfo.current = page; //分页处理

        let res = await alarmPage({
          ...this.pageInfo,
          oilSiteIds: [this.curId],
        })

        this.isdisble = true
        if (res.code === "00000") {
          const datas = res.data;
          this.warningLists = datas.records;
      
          this.pageInfo.total = datas.total;
        }


      },
      timeChange(times) {
        times = times / 1000

        let d = moment.duration(+times, "seconds");
        return Math.floor(d.asDays()) +
          "天" +
          d.hours() +
          "时" +
          d.minutes() +
          "分" +
          d.seconds() +
          "秒"
        return this.formatSeconds(times / 1000)

      },
    }
  }
</script>